export const getSenderEmail = () => {
    return window.location.hostname === 'localhost' ? 'info@baksystem.nl' : 'info@ridderendeprins.nl';
};
